// Yellow "you can't do this yet, do X first" banner used by the partner
// setup flows (Add Team, Activate Wallet, Add User with wallet, Assign Team,
// self-activate). role="status" (implicit aria-live="polite") so a screen
// reader announces the prerequisite when the state flips from met to missing
// without interrupting the user. role="alert" would map to assertive, which
// is reserved for urgent interruption; this is guidance, not an emergency.

const PrerequisiteAlert = ({ message, actionLabel, onAction, className = "mb-3" }) => (
  <div
    className={`alert alert-warning py-2 d-flex flex-wrap align-items-center gap-2 ${className}`}
    role="status"
  >
    <i className="fa fa-exclamation-triangle" aria-hidden="true" />
    <span className="flex-grow-1">{message}</span>
    {actionLabel && onAction && (
      <button
        type="button"
        className="btn btn-sm btn-outline-primary"
        onClick={onAction}
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default PrerequisiteAlert;
